// «Exportar CSV» de Ventas: descarga lo que lista la tabla. Vive al pie de la columna de filtros.
import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';

export function ExportSalesButton({
    canExport,
    onExport,
}: {
    canExport: boolean;
    onExport: () => void;
}) {
    const { t } = useTranslation('ventas');
    return (
        <button
            type="button"
            aria-disabled={!canExport}
            title={
                canExport
                    ? t('pagina.exportarTitulo', {
                          defaultValue: 'Descarga las ventas cargadas en CSV.',
                      })
                    : t('pagina.exportarVacio', {
                          defaultValue: 'No hay ventas cargadas para exportar',
                      })
            }
            onClick={() => {
                if (canExport) onExport();
            }}
            className="inline-flex h-[26px] w-full items-center justify-center gap-1 rounded-md border border-border bg-card text-[11px] font-medium text-foreground transition-colors hover:bg-accent aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-disabled:hover:bg-card"
        >
            <Download className="size-3" aria-hidden />
            {t('pagina.exportar', { defaultValue: 'Exportar CSV' })}
        </button>
    );
}
